import { render } from "./EditQuestion.vue?vue&type=template&id=7d199ea7&scoped=true"
import script from "./EditQuestion.vue?vue&type=script&lang=js"
export * from "./EditQuestion.vue?vue&type=script&lang=js"

import "./EditQuestion.vue?vue&type=style&index=0&id=7d199ea7&lang=less&scoped=true"
import "./EditQuestion.vue?vue&type=style&index=1&id=7d199ea7&lang=less"

import exportComponent from "/home/gitlab-runner/builds/LUZizzTB/0/unicorn/frontend/unicorn-fe-support/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d199ea7"]])

export default __exports__